// Where to go after signing in (?next=/oauth/consent?request=…). Only paths inside this app:
// "//evil.com" or "/\evil.com" would leave the site.
export const safeNext = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null
  if (value.startsWith('/login')) return null
  return value
}

/** "/login?next=…" for the current location (or plain "/login" from the home page). */
export const loginUrlFor = (location) => {
  const here = `${location.pathname}${location.search || ''}`
  return safeNext(here) && here !== '/' ? `/login?next=${encodeURIComponent(here)}` : '/login'
}
